export const partners = [
    {
        id:1,
        nameUA:"Ужгородський національний університет",
        nameEN:"Uzhhorod national university",
        link:"https://www.uzhnu.edu.ua/"
    },

    {
        id:"2",
        nameUA:"Закарпатська обласна організація профспілки працівників освіти і науки",
        nameEN:"Transcarpathian regional organization of the trade union of education and science workers",
        link:"https://oblpon.uz.ua/"
    },

    {
        id:"3",
        nameUA:"Профспілка працівників освіти і науки України",
        nameEN:"Trade Union of Education and Science Workers of Ukraine",
        link:"https://pon.org.ua/"
    },

    {
        id:"4",
        nameUA:"Студентська рада УжНУ",
        nameEN:"UzhNU Student Council",
        link:"https://www.uzhnu.edu.ua/uk/cat/student-self_government"
    }
];

